module.exports = __webpack_public_path__ + "static/media/sun.ee52be39.gif";